import React from "react";
import { Link, withRouter } from "react-router-dom";
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import Image from "react-bootstrap/Image";
import moment from "moment";
import { API_HOST } from "./utils/api-config";
import { makeStyles } from "@material-ui/core/styles";
import { Button, Fab, Chip } from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import ScheduleIcon from "@material-ui/icons/Schedule";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
      width: "25ch",
    },
  },
  button: {
    margin: theme.spacing(1),
  },
}));

const ShowDelivery = ({ delivery, edit }) => {
  const classes = useStyles();

  return (
    <Form>
      <Fab color="secondary" onClick={edit} aria-label="edit">
        <EditIcon />
      </Fab>
      {delivery.delivery.delivered ? (
        <Chip label={"Delivered"} clickable color={"primary"} />
      ) : (
        <Button
          variant="outlined"
          color="primary"
          size="large"
          className={classes.button}
          startIcon={<ScheduleIcon />}
        >
          <a
            style={{ textDecoration: "none" }}
            href={`${API_HOST}/book?f=${delivery.delivery.tracking_number.slice(
              8,
              16
            )}${delivery.delivery.scheduled ? "&commit=reschedule" : ""}`}
          >
            {delivery.delivery.scheduled ? "Reschedule" : "Schedule"}
          </a>
        </Button>
      )}

      {delivery.delivery.ontime && (
        <Chip label="Ontime" clickable color="primary" />
      )}
      <Chip
        label={
          delivery.delivery.entered_dc_at
            ? "In DC"
            : delivery.delivery.pickup
            ? "With Customer"
            : "In store"
        }
        clickable
        color={delivery.delivery.entered_dc_at ? "primary" : "secondary"}
      />
      <Form.Row>
        <Form.Group as={Col} controlId="formGridMerchantID">
          <Form.Label>Merchant ID</Form.Label>
          <Form.Control
            readOnly
            value={delivery.delivery.merchant_id}
            name="merchant_id"
          />
        </Form.Group>
        <Form.Group as={Col} controlId="formGridOrderId">
          <Form.Label>Order ID</Form.Label>
          <Form.Control
            readOnly
            value={
              delivery.delivery.order_id ? delivery.delivery.order_id : " "
            }
            name="order_id"
          />
        </Form.Group>
        <Form.Group as={Col} controlId="formGridFsaId">
          <Form.Label>Fsa ID</Form.Label>
          <Form.Control
            readOnly
            value={delivery.delivery.fsa_id ? delivery.delivery.fsa_id : ""}
            name="fsa_id"
          />
        </Form.Group>
        <Form.Group as={Col} controlId="formGridAuthor">
          <Form.Label>Scheduled by</Form.Label>
          <Link to={`/users/${delivery.delivery.created_by_user}`}>
            <Form.Control
              readOnly
              value={
                delivery.delivery.created_by_user
                  ? delivery.delivery.created_by_user
                  : ""
              }
              name="created_by_user"
            />
          </Link>
        </Form.Group>
        <Form.Group as={Col} controlId="formGridBookingId">
          <Form.Label>Booking ID</Form.Label>
          <Link to={`/timeslots/${delivery.delivery.booking_id}`}>
            <Form.Control
              readOnly
              value={
                delivery.delivery.booking_id ? delivery.delivery.booking_id : ""
              }
              name="booking_id"
            />
          </Link>
        </Form.Group>
        <Form.Group as={Col} controlId="formGridBookingIndex">
          <Form.Label>Booking Index</Form.Label>
          <Form.Control
            readOnly
            value={delivery.delivery.booking_index}
            name="booking_index"
          />
        </Form.Group>
      </Form.Row>
      <Form.Row>
        <Form.Group as={Col} controlId="formGridTotPrice">
          <Form.Label>Total Price</Form.Label>
          <Form.Control
            readOnly
            value={delivery.delivery.total_price}
            name="total_price"
          />
        </Form.Group>
        {delivery.delivery.number_of_bags && (
          <Form.Group as={Col} controlId="formGridBags">
            <Form.Label>Number of Bags/Boxes</Form.Label>
            <Form.Control
              readOnly
              value={delivery.delivery.number_of_bags}
              name="number_of_bags"
            />
          </Form.Group>
        )}
        <Form.Group as={Col} controlId="formGridPrice">
          <Form.Label>Price</Form.Label>
          <Form.Control readOnly value={delivery.delivery.price} name="price" />
        </Form.Group>
      </Form.Row>
      <Form.Row>
        {delivery.delivery.delivery_instructions && (
          <Form.Group as={Col} controlId="formGridInstructions">
            <Form.Label>Delivery Instructions</Form.Label>
            <Form.Control
              readOnly
              value={delivery.delivery.delivery_instructions}
              name="delivery_instructions"
            />
          </Form.Group>
        )}
        {delivery.delivery.delivery_notes && (
          <Form.Group as={Col} controlId="formGridNotes">
            <Form.Label>Delivery Notes</Form.Label>
            <Form.Control
              readOnly
              value={delivery.delivery.delivery_notes}
              name="delivery_notes"
            />
          </Form.Group>
        )}
      </Form.Row>
      {delivery.delivery.delivered ? (
        <Form.Row>
          <Form.Group as={Col} controlId="formGridDeliveredAt">
            <Form.Label>Delivered At</Form.Label>
            <Form.Control
              readOnly
              value={delivery.delivery.drop_off_time}
              name="drop_off_time"
            />
          </Form.Group>
          <Form.Group as={Col} controlId="formGridOntime">
            <Form.Label>Ontime</Form.Label>
            <Form.Check
              readOnly
              checked={delivery.delivery.ontime}
              name="ontime"
            />
          </Form.Group>
          <Form.Group as={Col} controlId="formGridImage">
            <Form.Label>Photo</Form.Label>
            <Image thumbnail src={delivery.delivery.customer_signature} />
          </Form.Group>
        </Form.Row>
      ) : (
        <Form.Row>
          <Form.Group as={Col} controlId="formGridWindow">
            <Form.Label>Selected Time</Form.Label>
            <Form.Control
              readOnly
              value={delivery.delivery.delivery_window}
              name="delivery_window"
            />
          </Form.Group>
          <Form.Group as={Col} controlId="formGridEnteredDcAt">
            <Form.Label>Entered DC At</Form.Label>
            <Form.Control
              readOnly
              value={
                delivery.delivery.entered_dc_at
                  ? delivery.delivery.entered_dc_at
                  : ""
              }
              name="entered_dc_at"
            />
          </Form.Group>
          <Form.Group as={Col} controlId="formGridDate">
            <Form.Label>Delivery Date</Form.Label>
            <Form.Control
              readOnly
              value={delivery.delivery.date}
              name="delivery_date"
            />
          </Form.Group>
        </Form.Row>
      )}
      {delivery.delivery.failed_notes &&
        delivery.delivery.failed_notes.length > 0 && (
          <Form.Row>
            <Form.Group as={Col} controlId={`formGridNotes`}>
              <Form.Label>Failed Attempts</Form.Label>
              {delivery.delivery.failed_notes.map((note, i) => (
                <Form.Control
                  value={`${moment(delivery.delivery.failed_at[i]).format(
                    "MMMM Do, h:mm a"
                  )}
                ${delivery.delivery.failed_notes[i]}`}
                  name="retailers_notes"
                  readOnly
                />
              ))}
            </Form.Group>
          </Form.Row>
        )}
      {delivery.delivery.cancelled && (
        <Form.Row>
          <Form.Group as={Col} controlId="formGridCancelled">
            <Form.Label>Cancelled</Form.Label>
            <Form.Check
              readOnly
              checked={delivery.delivery.cancelled}
              name="cancelled"
            />
          </Form.Group>
          <Form.Group as={Col} controlId="formGridCancelledAt">
            <Form.Label>Cancelled At</Form.Label>
            <Form.Control
              readOnly
              value={
                delivery.delivery.cancelled_at
                  ? delivery.delivery.cancelled_at
                  : ""
              }
              name="cancelled_at"
            />
          </Form.Group>
          <Form.Group as={Col} controlId="formGridCancelledBy">
            <Form.Label>Cancelled By</Form.Label>
            <Form.Control
              readOnly
              value={
                delivery.delivery.cancelled
                  ? delivery.delivery.cancelled_by == 0
                    ? "Shopify"
                    : delivery.delivery.cancelled_by
                  : ""
              }
              name="cancelled_by"
            />
          </Form.Group>
        </Form.Row>
      )}
    </Form>
  );
};
// }

export default withRouter(ShowDelivery);
